import { computed, ref } from 'vue';

export type SharingStep = 'intro' | 'campaigns' | 'form' | 'redirect';

export const useSharingSteps = (initialStep: SharingStep = 'intro') => {
  const currentStep = ref<SharingStep>(initialStep);

  const goToStep = (step: SharingStep) => {
    currentStep.value = step;
  };

  const isIntro = computed(() => currentStep.value === 'intro');
  const isCampaigns = computed(() => currentStep.value === 'campaigns');
  const isForm = computed(() => currentStep.value === 'form');
  const isRedirect = computed(() => currentStep.value === 'redirect');

  return {
    currentStep,
    goToStep,
    isIntro,
    isCampaigns,
    isForm,
    isRedirect,
  };
};
